import React, { useState } from "react";
import Layout from "../components/Layout";

function TrainingVideos() {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");

  // Simplified video categories
  const videoCategories = [
    {
      id: "getting-started",
      name: "Getting Started",
      icon: "bi-play-circle",
      color: "primary",
    },
    {
      id: "job-coaches",
      name: "For Job Coaches",
      icon: "bi-person-workspace",
      color: "success",
    },
    {
      id: "administrators",
      name: "For Administrators",
      icon: "bi-gear",
      color: "warning",
    },
    {
      id: "reporting",
      name: "Reports & Analytics",
      icon: "bi-graph-up",
      color: "info",
    },
  ];

  return (
    <Layout>
      <div className="min-vh-100 d-flex flex-column">
        {/* Navbar */}
        {/* <nav className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top">
        <div className="container">
          <a className="navbar-brand fw-bold" href="/">
            <i className="bi bi-layers me-2"></i>
            WebVenly
          </a>
          <div className="d-flex">
            <a href="/" className="btn btn-outline-light">
              <i className="bi bi-arrow-left me-2"></i>
              Back to Home
            </a>
          </div>
        </div>
      </nav> */}

        {/* Hero Section */}
        <section className="bg-gradient-primary text-white py-5">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-8 mx-auto text-center">
                <h1 className="display-4 fw-bold mb-4">Training Videos</h1>
                <p className="lead mb-4">
                  Master WebVenly with our comprehensive video training library
                </p>
                <div className="d-flex justify-content-center gap-3 flex-wrap">
                  <div className="badge bg-primary bg-opacity-75 px-3 py-2">
                    <i className="bi bi-play-circle me-2"></i>
                    Step-by-Step Guides
                  </div>
                  <div className="badge bg-success bg-opacity-75 px-3 py-2">
                    <i className="bi bi-person-check me-2"></i>
                    Role-Based Training
                  </div>
                  <div className="badge bg-warning bg-opacity-75 px-3 py-2">
                    <i className="bi bi-clock me-2"></i>
                    Short & Focused
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Video Content Placeholder */}
        <section className="py-5 flex-grow-1">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="video-placeholder-container bg-light rounded-4 p-5 text-center border border-2 border-dashed">
                  <div className="mb-4">
                    <i className="bi bi-camera-video display-1 text-muted mb-3"></i>
                    <h3 className="text-muted mb-3">Training Videos</h3>
                    <p className="lead text-muted mb-4">
                      Job Coach videos are available. But, we're currently
                      developing comprehensive video training content for all
                      aspects of the WebVenly platform.
                    </p>
                  </div>

                  {/* Preview of what's coming */}
                  <div className="row g-3 mb-4">
                    <div className="col-md-6">
                      <a
                        href="/gettingstarted"
                        className="text-decoration-none"
                      >
                        <div className="video-preview-card bg-white rounded-3 p-3 shadow-sm h-100 d-flex flex-column">
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <i className="bi bi-play-circle text-primary fs-4"></i>
                            <span className="badge bg-success">
                              Available Now
                            </span>
                          </div>
                          <h6 className="mb-1 text-primary">
                            Getting Started Guide
                          </h6>
                          <small className="text-muted mb-2 flex-grow-1">
                            5-step interactive guide to master the basics
                          </small>
                          <div className="d-flex align-items-center justify-content-between mt-auto">
                            <small className="text-success">
                              <i className="bi bi-check-circle me-1"></i>
                              Start now
                            </small>
                            <i className="bi bi-arrow-right text-primary"></i>
                          </div>
                        </div>
                      </a>
                    </div>
                    {/* <div className="col-md-6">
                    <div className="video-preview-card bg-white rounded-3 p-3 shadow-sm h-100 d-flex flex-column">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <i className="bi bi-phone text-success fs-4"></i>
                        <span className="badge bg-secondary">Coming Soon</span>
                      </div>
                      <h6 className="mb-1">Mobile App Training</h6>
                      <small className="text-muted mb-2 flex-grow-1">
                        Job logging and mileage tracking videos
                      </small>
                      <div className="mt-auto">
                        <small className="text-muted">
                          <i className="bi bi-hourglass-split me-1"></i>
                          Video series in development
                        </small>
                      </div>
                    </div>
                  </div> */}
                    <div className="col-md-6">
                      <a href="/adminfeatures" className="text-decoration-none">
                        <div className="video-preview-card bg-white rounded-3 p-3 shadow-sm h-100 d-flex flex-column">
                          <div className="d-flex align-items-center justify-content-between mb-2">
                            <i className="bi bi-gear text-warning fs-4"></i>
                            <span className="badge bg-warning">In Process</span>
                          </div>
                          <h6 className="mb-1 text-warning">
                            Admin Features Training
                          </h6>
                          <small className="text-muted mb-2 flex-grow-1">
                            Complete admin guide for user management and system
                            setup
                          </small>
                          <div className="d-flex align-items-center justify-content-between mt-auto">
                            <small className="text-success">
                              <i className="bi bi-check-circle me-1"></i>
                              Start training
                            </small>
                            <i className="bi bi-arrow-right text-warning"></i>
                          </div>
                        </div>
                      </a>
                    </div>
                    {/* <div className="col-md-6">
                    <div className="video-preview-card bg-white rounded-3 p-3 shadow-sm h-100 d-flex flex-column">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <i className="bi bi-graph-up text-info fs-4"></i>
                        <span className="badge bg-secondary">Coming Soon</span>
                      </div>
                      <h6 className="mb-1">Reports & Analytics</h6>
                      <small className="text-muted mb-2 flex-grow-1">
                        Generate and customize reports
                      </small>
                      <div className="mt-auto">
                        <small className="text-muted">
                          <i className="bi bi-hourglass-split me-1"></i>
                          Reporting guides coming
                        </small>
                      </div>
                    </div>
                  </div> */}
                  </div>

                  {/* Action buttons */}
                  <div className="d-flex gap-3 justify-content-center flex-wrap">
                    <a href="/demo" className="btn btn-primary">
                      <i className="bi bi-calendar-check me-2"></i>
                      Schedule Live Demo
                    </a>
                    <a href="/contact" className="btn btn-outline-primary">
                      <i className="bi bi-envelope me-2"></i>
                      Request Training
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="bg-dark text-white py-4 mt-auto">
          <div className="container text-center">
            <p className="mb-1">
              &copy; {new Date().getFullYear()} WebVenly. All rights reserved.
            </p>
            <p className="mb-0 small text-light">
              Powered by <strong>Wyatt Multi Solutions</strong>
            </p>
          </div>
        </footer>

        <style jsx>{`
          .video-placeholder-container {
            min-height: 400px;
            display: flex;
            flex-direction: column;
            justify-content: center;
          }

          .video-preview-card {
            transition: all 0.3s ease;
            height: 100%;
          }

          .video-preview-card:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
          }

          .bg-gradient-primary {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          }

          @media (max-width: 768px) {
            .video-placeholder-container {
              min-height: 300px;
              padding: 2rem 1rem !important;
            }

            .display-1 {
              font-size: 3rem !important;
            }
          }
        `}</style>
      </div>
    </Layout>
  );
}

export default TrainingVideos;
